var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8889 7.66677V6.11122C13.8889 5.25211 13.1924 4.55566 12.3333 4.55566H4.55556C3.69645 4.55566 3 5.25211 3 6.11122V10.7779C3 11.637 3.69645 12.3334 4.55556 12.3334H6.11111M7.66667 15.4446H15.4444C16.3036 15.4446 17 14.7481 17 13.889V9.22233C17 8.36322 16.3036 7.66677 15.4444 7.66677H7.66667C6.80756 7.66677 6.11111 8.36322 6.11111 9.22233V13.889C6.11111 14.7481 6.80756 15.4446 7.66667 15.4446ZM13.1111 11.5557C13.1111 12.4148 12.4147 13.1112 11.5556 13.1112C10.6964 13.1112 10 12.4148 10 11.5557C10 10.6966 10.6964 10.0001 11.5556 10.0001C12.4147 10.0001 13.1111 10.6966 13.1111 11.5557Z",
    stroke: "#171717",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.eaa4ef25.svg";
export { ForwardRef as ReactComponent };